export default __webpack_public_path__ + "static/media/lorcana_enchanted.47c716e1.svg";